import {ValidationType} from './ValidationType'

export const MarketingEmailItemsValidation = {
  ID: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  Description: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: true,
    maxLength: 50,
    maxValue: 0
  },
  Body: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 255,
    maxValue: 0
  },
  Type: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  URL: {
    validationType: ValidationType.WebPage,
    isRequired: true,
    maxLength: 255,
    maxValue: 0
  },
  Image: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  }
};
